var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/dnd-core/~/lodash/_getPrototype.js
 ** module id = 867
 ** module chunks = 0
 **/